var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#1C4F9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4287 23.5714L23.5716 16.4286",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8091 12.8571L19.3603 12.2191C20.4767 11.1028 21.9909 10.4757 23.5696 10.4758C25.1484 10.4759 26.6624 11.1032 27.7787 12.2196C28.895 13.3361 29.5221 14.8502 29.5219 16.429C29.5218 18.0078 28.8946 19.5218 27.7781 20.6381L27.1424 21.1905",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.19 27.1428L20.7174 27.7786C19.588 28.8954 18.0636 29.5219 16.4752 29.5219C14.8867 29.5219 13.3624 28.8954 12.2329 27.7786C11.6762 27.2281 11.2342 26.5726 10.9326 25.8502C10.6309 25.1277 10.4756 24.3525 10.4756 23.5696C10.4756 22.7867 10.6309 22.0116 10.9326 21.2891C11.2342 20.5666 11.6762 19.9112 12.2329 19.3607L12.8567 18.8095",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.d0227425e7cf775b86f2c79db8a7a538.svg";
export { ForwardRef as ReactComponent };